import React from 'react';
import { ScrollArea } from '@mantine/core';

export const Scrollable: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isLargeMobileScreen =
    typeof window !== 'undefined' && Math.max(window.screen.width, window.screen.height) >= 896;

  if (isLargeMobileScreen) {
    return <>{children}</>;
  }

  return (
    <ScrollArea.Autosize h={'35dvh'} type="auto" offsetScrollbars>
      {children}
    </ScrollArea.Autosize>
  );
};
